import { render, staticRenderFns } from "./Strats.vue?vue&type=template&id=2f701611&scoped=true&"
import script from "./Strats.vue?vue&type=script&lang=js&"
export * from "./Strats.vue?vue&type=script&lang=js&"
import style0 from "./Strats.vue?vue&type=style&index=0&id=2f701611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f701611",
  null
  
)

export default component.exports